let previousPage = null;

/**
 * send event tracking information to google
 */
export const send = (eventCategory, eventAction, eventLabel = null, eventValue = null) => {
    if (!eventCategory) {
        throw new Error('eventCategory is required');
    }

    if (!eventAction) {
        throw new Error('eventAction is required');
    }

    try {
        if (ga) {
            ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
        }
    } catch (err) { }
}


/**
 * Track a page view with Google
 * @param {location} location the location for the page view
 * @param {string} trackerName the name of the tracker
 */
export const trackPageView = (location, trackerName) => {
    if (!location) {
        throw new Exception('location is required');
    }
    const page = `${location.href}`;
    if (page !== previousPage) {
        trackGAPageView(page, trackerName);
        previousPage = page;
    }
};

const trackGAPageView = (page, trackerName) => {
    try {
        if (ga) {
            ga('set', 'page', page);

            if (trackerName) {
                trackerName = `${trackerName}.send`;
            } else {
                trackerName = 'send';
            }
            ga(trackerName, 'pageview');
        }
    } catch (err) { }
}

export const onHelmetChangeClientState = newState => {
    if (newState.title) {
        trackPageView(location);
        window.scrollTo(0, 0);
    }
};



// WEBPACK FOOTER //
// ./src/utils/Analytics.js